import { vec3 } from 'gl-matrix'

import { Vec3ToHex } from '@/webgl/core/Color'
import Deferred from '@/webgl/core/Deferred'
import Renderer from '@/webgl/Renderer'
import ColorTransition from '@/webgl/runner/animations/ColorTransition'
import IAnimationTrack from '@/webgl/runner/interfaces/IAnimationTrack'

type ClearColorAnimationOptions = {
  delay: number
  duration: number
  targetColor: number
}

export default class ClearColorAnimation implements IAnimationTrack {
  options: ClearColorAnimationOptions
  _tween: ColorTransition

  constructor(
    readonly renderer: Renderer,
    options: Partial<ClearColorAnimationOptions> = {}
  ) {
    this.options = {
      delay: 0,
      duration: 1,
      targetColor: 0,
      ...options,
    }
  }

  init(): void {
    const c = vec3.create()
    c[0] = this.renderer.clearColor[0]
    c[1] = this.renderer.clearColor[1]
    c[2] = this.renderer.clearColor[2]
    this._tween = new ColorTransition(Vec3ToHex(c))
  }

  play(): Promise<unknown> {
    const defered = new Deferred<void>()
    this._tween.to(this.options.targetColor, {
      duration: this.options.duration,
      delay: this.options.delay,
      onUpdate: () => this.renderer.setClearColor(this._tween.Hex),
      onComplete: defered.resolve,
    })
    return defered.promise
  }
}
